import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import React, { useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { Gap } from "../../atoms";
import { Grid,Paper } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Map from "./map";
import Table from "./table";
// import { getPengurusProvinsi,getPengurusKabkot,getPengurusKecamatan } from "../../../config/Redux/Pengurus/actions";
import { getOverviewKabkot,getOverviewProvinsi,getOverviewKecamatan } from "../../../config/Redux/Overview/actions";

const DetailPengurus = () => {
  const dispatch = useDispatch();
  let params = useParams();
  // const { state } = useLocation();
	const [toggle, setToggle] = useState('asc');
	const [orderBy, setOrderBy] = useState('nama_provinsi');
	const [selectFilterPemenuhanTarget, setFilterPemenuhanTarget] = useState('0');
	const [selectFilterProvinsi, setFilterProvisni] = useState('0');
	const [optionOrderBy, setOptionOrder] = useState([]);
	const dataPengurus = useSelector((state) => state.pengurus);
	// console.log(dataPengurus)

	const listProvinsi = useSelector((state) => state.global.dataProvince);
  const provinces = [{kode_prov_bps:"0",nama_prov_kemdagri:"Semua Provinsi"}]
	for(let i=0; i<listProvinsi?.data?.length;i++){
		provinces.push(listProvinsi.data[i])
	}

	const [dataPengurusAll, setDataPengurusAll] = useState([]);
	const dataOverview = useSelector((state) => state.overview);
	// console.log(dataOverview)


	const getSubValue = (id,key,datasubArea) =>{
		let value = "";
		for(let i=0;i<datasubArea?.length;i++){
			if(id === datasubArea[i].id){
				value = datasubArea[i][key]
			}
		}
		return value
	}

	const updateData = (sortType,sortBy,filterTarget,filterProvinsi) =>{
		let arr = [];
		let parameter1 = "";
		if(params?.tingkatExcoId === "2"){
			parameter1 = "jumlah_pengurus";
			arr = dataOverview?.dataOverviewProvinsi?.data?.data || [];
		} else if(params?.tingkatExcoId === "3"){
			parameter1 = "jumlah_pengurus_kabkot";
			arr = dataOverview?.dataOverviewKabkot?.data?.data || [];
		} else if(params?.tingkatExcoId === "4"){
			parameter1 = "jumlah_pengurus_kecamatan";
			arr = dataOverview?.dataOverviewKecamatan?.data?.data || [];
		}
		let newArray = [];
		if(sortType === "asc"){
			newArray = arr.sort((a, b) => a[sortBy] > b[sortBy] ? 1 : -1);
		} else {
			newArray = arr.sort((a, b) => a[sortBy] < b[sortBy] ? 1 : -1);
		}

		if(filterProvinsi !== "0"){
			newArray = newArray.filter(function (el) {
				return el.id_provinsi === parseInt(filterProvinsi)
			});
		}

		if(filterTarget !== "0"){
			if(filterTarget === "1"){
				newArray = newArray.filter(function (el) {
					if(params?.tingkatExcoId === "4"){
						return (el?.info_dokumen?.dokumen_foto_kantor === 1 &&
							el?.info_dokumen?.dokumen_sk_pengurus === 1)
					} else {
						return (el?.info_dokumen?.dokumen_foto_kantor === 1 && 
							el?.info_dokumen?.dokumen_domisili === 1 &&
							el?.info_dokumen?.dokumen_kesbangpol === 1 &&
							el?.info_dokumen?.dokumen_rekening === 1 &&
							el?.info_dokumen?.dokumen_sewa_kantor === 1 &&
							el?.info_dokumen?.dokumen_sk_pengurus === 1)
					}
				});
			} else if(filterTarget === "2"){
				newArray = newArray.filter(function (el) {
					if(params?.tingkatExcoId === "4"){
						return (el?.info_dokumen?.dokumen_foto_kantor === 1 ||
							el?.info_dokumen?.dokumen_sk_pengurus === 1)
					} else {
						return (el?.info_dokumen?.dokumen_foto_kantor === 1 || 
							el?.info_dokumen?.dokumen_domisili === 1 ||
							el?.info_dokumen?.dokumen_kesbangpol === 1 ||
							el?.info_dokumen?.dokumen_rekening === 1 ||
							el?.info_dokumen?.dokumen_sewa_kantor === 1 ||
							el?.info_dokumen?.dokumen_sk_pengurus === 1)
					}
				});
			} else if (filterTarget === "3"){
				newArray = newArray.filter(function (el) {
					return el[parameter1] > 0 && el?.info_dokumen?.dokumen_sk_pengurus === 1
				});
			} else if (filterTarget === "4"){
				newArray = newArray.filter(function (el) {
					if(params?.tingkatExcoId === "4"){
						return (el?.info_dokumen?.dokumen_sk_pengurus === 1)
					} else {
						return (el?.info_dokumen?.dokumen_kesbangpol === 1 &&
							el?.info_dokumen?.dokumen_sk_pengurus === 1)
					}
				});
			} 
			else if (filterTarget === "5"){
				newArray = newArray.filter(function (el) {
					if(params?.tingkatExcoId === "4"){
						return (el?.info_dokumen?.dokumen_foto_kantor === 1)
					} else {
						return (el?.info_dokumen?.dokumen_foto_kantor === 1 && 
							el?.info_dokumen?.dokumen_domisili === 1 &&
							el?.info_dokumen?.dokumen_sewa_kantor === 1)
					}
				});
			} else if (filterTarget === "6"){
				newArray = newArray.filter(function (el) {
					return (el?.info_dokumen?.dokumen_rekening === 1)
				});
			} else {
				newArray = newArray.filter(function (el) {
					if(params?.tingkatExcoId === "4"){
						return (el?.info_dokumen?.dokumen_foto_kantor === 0 &&
							el?.info_dokumen?.dokumen_sk_pengurus === 0)
					} else {
						return (el?.info_dokumen?.dokumen_foto_kantor === 0 && 
							el?.info_dokumen?.dokumen_domisili === 0 &&
							el?.info_dokumen?.dokumen_kesbangpol === 0 &&
							el?.info_dokumen?.dokumen_rekening === 0 &&
							el?.info_dokumen?.dokumen_sewa_kantor === 0 &&
							el?.info_dokumen?.dokumen_sk_pengurus === 0)
					}
				});
			}
		}
		setDataPengurusAll(newArray)
	}

	
	const handleSort = (event) => {
    setOrderBy(event.target.value)
		updateData(toggle,event.target.value,selectFilterPemenuhanTarget,selectFilterProvinsi)
  }
  const handleSortType = (value) => {
    setToggle(value)
		updateData(value,orderBy,selectFilterPemenuhanTarget,selectFilterProvinsi)
  }
	const handleFilterPemenuhanSyarat = (event) => {
    setFilterPemenuhanTarget(event.target.value)
		updateData(toggle,orderBy,event.target.value,selectFilterProvinsi)
  }
	const handleProvinsi = (event) => {
    setFilterProvisni(event.target.value)
		updateData(toggle,orderBy,selectFilterPemenuhanTarget,event.target.value)
  }

	useEffect(() => {
		if(params?.tingkatExcoId === "2"){
			setOrderBy('nama_provinsi');
			setOptionOrder([
				{
					id:"nama_provinsi",
					label:"Nama Provinsi"
				},
			])
		} else if(params?.tingkatExcoId === "3"){
			setOrderBy('nama_provinsi');
			setOptionOrder([
				{
					id:"nama_provinsi",
					label:"Nama Provinsi"
				},
				{
					id:"nama_kab_kot",
					label:"Nama Kab/Kota"
				},
			])
		} else if(params?.tingkatExcoId === "4"){
			setOrderBy('nama_provinsi');
			setOptionOrder([
				{
					id:"nama_provinsi",
					label:"Nama Provinsi"
				},
				{
					id:"nama_kab_kot",
					label:"Nama Kab/Kota"
				},
				{
					id:"nama_kecamatan",
					label:"Nama Kecamatan"
				},
			])
		}
		if(!dataOverview?.dataOverviewKabkot?.data?.data?.length){
			dispatch(getOverviewProvinsi(true));
			dispatch(getOverviewKabkot(true));
			dispatch(getOverviewKecamatan(false));
		}
		if(params?.tingkatExcoId === "2"){
			setFilterProvisni("0")
			setFilterPemenuhanTarget('0')
			updateData(toggle,"nama_provinsi",'0',"0")
		} else {
			setFilterProvisni(params?.idProvince)
			setFilterPemenuhanTarget('0')
			updateData(toggle,"nama_provinsi",'0',params?.idProvince)
		}
  }, [params?.tingkatExcoId,dataOverview?.dataOverviewKabkot?.data?.data?.length]);

  const breadcrumbs = [
    <Link
      to={"/overview"}
      style={{ textDecoration: "none", fontWeight: "bold", color: "black", fontSize:'14px' }}
    >
      Overview
    </Link>,
    (params?.tingkatExcoId === "2")?
      (
        <Typography key="2" color="text.primary" style={{ color: "#BDBDBD", fontSize:'14px', marginTop:'2px' }}>
          Provinsi
        </Typography>
      )
    : (params?.tingkatExcoId === "3" || params?.tingkatExcoId === "4")?
      (
				<Link
					to={"/dokumen/2/0/0"}
					style={{ textDecoration: "none", fontWeight: "bold", color: "black", fontSize:'14px' }}
				>
					Provinsi
				</Link>
			)
			:""
			,
			(params?.tingkatExcoId === "3")?
				(
					<Typography key="2" color="text.primary" style={{ color: "#BDBDBD", fontSize:'14px', marginTop:'2px' }}>
						Kab/Kota
					</Typography>
				)
			:
			(params?.tingkatExcoId === "4")?
				(
					<Link
						to={"/dokumen/3/"+params?.idProvince+"/0"}
						style={{ textDecoration: "none", fontWeight: "bold", color: "black", fontSize:'14px' }}
					>
						Kab/Kota
						{/* {`${dataPengurus?.dataPengurusKecamatan?.data?.length? dataPengurus?.dataPengurusKecamatan?.data[0]?.nama_kab_kot:''}`} */}
					</Link>
			)
			:""
			,
			(params?.tingkatExcoId === "4")?
				(
					<Typography key="2" color="text.primary" style={{ color: "#BDBDBD", fontSize:'14px', marginTop:'2px' }}>
						Kecamatan
					</Typography>
				)
			:""
  ];

	const filterData = (newArray, filterTarget) => {
		let parameter1 = "";
		if(params?.tingkatExcoId === "2"){
			parameter1 = "jumlah_pengurus";
		} else if(params?.tingkatExcoId === "3"){
			parameter1 = "jumlah_pengurus_kabkot";
		} else if(params?.tingkatExcoId === "4"){
			parameter1 = "jumlah_pengurus_kecamatan";
		}
		if(filterTarget !== "0"){
			if(filterTarget === "1"){
				newArray = newArray.filter(function (el) {
					if(params?.tingkatExcoId === "4"){
						return (el?.info_dokumen?.dokumen_foto_kantor === 1 &&
							el?.info_dokumen?.dokumen_sk_pengurus === 1)
					} else {
						return (el?.info_dokumen?.dokumen_foto_kantor === 1 && 
							el?.info_dokumen?.dokumen_domisili === 1 &&
							el?.info_dokumen?.dokumen_kesbangpol === 1 &&
							el?.info_dokumen?.dokumen_rekening === 1 &&
							el?.info_dokumen?.dokumen_sewa_kantor === 1 &&
							el?.info_dokumen?.dokumen_sk_pengurus === 1)
					}
				});
			} else if(filterTarget === "2"){
				newArray = newArray.filter(function (el) {
					if(params?.tingkatExcoId === "4"){
						return (el?.info_dokumen?.dokumen_foto_kantor === 1 ||
							el?.info_dokumen?.dokumen_sk_pengurus === 1)
					} else {
						return (el?.info_dokumen?.dokumen_foto_kantor === 1 || 
							el?.info_dokumen?.dokumen_domisili === 1 ||
							el?.info_dokumen?.dokumen_kesbangpol === 1 ||
							el?.info_dokumen?.dokumen_rekening === 1 ||
							el?.info_dokumen?.dokumen_sewa_kantor === 1 ||
							el?.info_dokumen?.dokumen_sk_pengurus === 1)
					}
				});
			} else if (filterTarget === "3"){
				newArray = newArray.filter(function (el) {
					return el[parameter1] > 0 && el?.info_dokumen?.dokumen_sk_pengurus === 1
				});
			} else if (filterTarget === "4"){
				newArray = newArray.filter(function (el) {
					if(params?.tingkatExcoId === "4"){
						return (el?.info_dokumen?.dokumen_sk_pengurus === 1)
					} else {
						return (el?.info_dokumen?.dokumen_kesbangpol === 1 &&
							el?.info_dokumen?.dokumen_sk_pengurus === 1)
					}
				});
			} 
			else if (filterTarget === "5"){
				newArray = newArray.filter(function (el) {
					if(params?.tingkatExcoId === "4"){
						return (el?.info_dokumen?.dokumen_foto_kantor === 1)
					} else {
						return (el?.info_dokumen?.dokumen_foto_kantor === 1 && 
							el?.info_dokumen?.dokumen_domisili === 1 &&
							el?.info_dokumen?.dokumen_sewa_kantor === 1)
					}
				});
			} else if (filterTarget === "6"){
				newArray = newArray.filter(function (el) {
					return (el?.info_dokumen?.dokumen_rekening === 1)
				});
			} else {
				newArray = newArray.filter(function (el) {
					if(params?.tingkatExcoId === "4"){
						return (el?.info_dokumen?.dokumen_foto_kantor === 0 &&
							el?.info_dokumen?.dokumen_sk_pengurus === 0)
					} else {
						return (el?.info_dokumen?.dokumen_foto_kantor === 0 && 
							el?.info_dokumen?.dokumen_domisili === 0 &&
							el?.info_dokumen?.dokumen_kesbangpol === 0 &&
							el?.info_dokumen?.dokumen_rekening === 0 &&
							el?.info_dokumen?.dokumen_sewa_kantor === 0 &&
							el?.info_dokumen?.dokumen_sk_pengurus === 0)
					}
				});
			}
		}
		return newArray?.length || 0
	}

  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
			<div className="overview-detail-header">
				<Gap height={40} />
				<Breadcrumbs separator="›" aria-label="breadcrumb">
					{breadcrumbs}
				</Breadcrumbs>
				<Grid container spacing={0}>
					<Grid item xs={12} sm={8} md={6}>
						<p style={{ fontSize: 24, fontWeight: 'bold', margin:"8px 0px" }}>
							{params?.tingkatExcoId === "2" ? "Dokumen Provinsi" : (params?.tingkatExcoId === "3")? "Dokumen Kab/Kota":"Dokumen Kecamatan"}
						</p>
					</Grid>
					<Grid item xs={12} sm={4} md={6}>
						{(params?.tingkatExcoId !== "2")?
						<div className="overview-filter-group">
							<span>Saring Provinsi</span><br/>
							<select className="overview-filter-select" onChange={handleProvinsi} value={selectFilterProvinsi}>
								{provinces.map((list,key)=>{
									return (
										<option value={list.kode_prov_bps} key={key}>{list.nama_prov_kemdagri}</option>
									)
								})}
							</select>
						</div>
						:null}
						<div className="overview-filter-group" onChange={handleFilterPemenuhanSyarat}>
							<span>Saring Pemenuhan Syarat</span><br/>
							<select className="overview-filter-select" value={selectFilterPemenuhanTarget}>
								<option value="0">Tampil Semua</option>
								<option value="1">Dokumen Lengkap</option>
								<option value="2">Dokumen Lengkap Sebagian</option>
								{/* <option value="3">Keberadaan Exco</option>
								<option value="4">Dokumen Kepengurusan Lengkap</option>
								<option value="5">Dokumen Kantor Tetap Lengkap</option>
								<option value="6">Dokumen Bank Lengkap</option> */}
								<option value="7">Dokumen Tidak Ada</option>
							</select>
						</div>
					</Grid>
				</Grid>
			</div>
			<Gap height={120} />
			<Gap height={20} />
			<Paper className="overview-paper-secondary">
				<Map dataPengurusAll={dataPengurusAll}/>
			</Paper>
			<Gap height={20} />
			<Paper className="overview-paper-secondary">
				<Grid container spacing={2}>
					<Grid item xs={6} sm={6} md={3}>
						<div className="overview-paper-card">
							<p className="overview-main-value">
								{filterData(dataPengurusAll,"3")}
								{/* <span className="overview-secondary-value">
									{' '}/{countDaerah(dataOverview?.dataOverviewKecamatan?.data?.data,verified_region)?.toLocaleString().replace(/,/g,".",)}
								</span> */}
							</p>
							<p className="overview-title-value">Keberadaan Exco</p>
						</div>
					</Grid>
					<Grid item xs={6} sm={6} md={3}>
						<div className="overview-paper-card">
							<p className="overview-main-value">
								{filterData(dataPengurusAll,"1")}
								{/* <span className="overview-secondary-value">
									{' '}/{dataPengurus?.data?.total_wilayah?.pusat}
								</span> */}
							</p>
							<p className="overview-title-value">Dokumen Lengkap</p>
						</div>
					</Grid>
					<Grid item xs={6} sm={6} md={3}>
						<div className="overview-paper-card">
							<p className="overview-main-value">
								{filterData(dataPengurusAll,"2")}
								{/* <span className="overview-secondary-value">
									{' '}/{countDaerah(dataOverview?.dataOverviewProvinsi?.data?.data,verified_region)}
								</span> */}
							</p>
							<p className="overview-title-value">Dokumen Lengkap Sebagian</p>
						</div>
					</Grid>
					<Grid item xs={6} sm={6} md={3}>
						<div className="overview-paper-card">
							<p className="overview-main-value">
								{filterData(dataPengurusAll,"7")}
								{/* <span className="overview-secondary-value">
									{' '}/{countDaerah(dataOverview?.dataOverviewKabkot?.data?.data,verified_region)}
								</span> */}
							</p>
							<p className="overview-title-value">Belum Ada Dokumen</p>
						</div>
					</Grid>
				</Grid>
			</Paper>
			<Gap height={20} />
			<Paper className="overview-paper-secondary">
				<div className="overview-filter">
					<span style={{fontSize:'14px', fontWeight:'bold'}}>Urutkan berdasarkan</span>
					<select className="overview-filter-select" onChange={handleSort} value={orderBy}>
						{optionOrderBy.map((option, index)=>{
							return(
							<option value={option.id} key={index}>{option.label}</option>
							)
						})}
					</select>
					<div className="overview-toggle">
						<div className={(toggle==="asc")?"active":""} onClick={() => handleSortType('asc')}>Asc</div>
						<div className={(toggle==="desc")?"active":""} onClick={() => handleSortType('desc')}>Desc</div>
					</div>
				</div>
				<Table dataPengurusAll={dataPengurusAll}/>
			</Paper>
      <Gap height={10} />
      <div className="footer-content"></div>
    </div>
  );
};

export default DetailPengurus;
